export default __webpack_public_path__ + "static/media/NotoSerif-BoldItalic.c49fbd93.woff";